/** Shared existing capture window; completed server ledgers retain one extra day.
 * Manual native creates stop replaying at this earlier boundary. */
export const MOBILE_CAPTURE_BACKDATE_MS = 30 * 24 * 60 * 60_000;
